import React, { useEffect, useState } from 'react'
import { ArrayTotalizarByProp } from '../../Actions/TotalizarProps';
import { FormatMoney } from '../../../../Helpers/FormatNumber';
import { Nivel4Screen } from './Nivel4Screen';

export const Nivel3Screen = ({ data, nivel2, group, n1total, n1totalanterior }) => {
    const [state, setState] = useState([]);
    const [nivel3, setNivel3] = useState([]);
    const [totales, setTotales] = useState({
        total: 0,
        totalanterior: 0,
        variacion: 0
    })
    useEffect(() => {
        if (data === undefined || data == null || data.lenght === 0) {
            setState([]);
            return;
        }

        var arrayfilter = data.filter(x => x.nivel2 === nivel2);
        setNivel3(arrayfilter);
        var array = arrayfilter.reduce(function (groups, item) {
            var val = item['nivel3']
            groups[val] = groups[val] || val;
            return groups;
        }, {});
        setState(Object.values(array));
    }, [data])

    useEffect(() => {
        setTotales({
            total: ArrayTotalizarByProp(nivel3, "total"),
            totalanterior: ArrayTotalizarByProp(nivel3, 'totalanterior'),
            variacion: ArrayTotalizarByProp(nivel3, 'variacion')
        })
    }, [nivel3])

    if (state.length == 0) return <div></div>

    const capitalizeWords = (str) => {
        return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
      }; 


    return (
        <>
            {state.map(item => (
                <>
                    <tr>
                        {/* <td></td> */}
                        <td className='nivel3'></td>
                        <td colSpan={8} className='nivel3'>{capitalizeWords(item)}</td>
                    </tr>
                    <Nivel4Screen data={nivel3}
                        nivel3={item}
                        n1total={n1total}
                        n1totalanterior={n1totalanterior}
                        group={item}
                    />
                    <tr className='tr-espacion-5'></tr>
                </>
            ))}

            <tr className='Nivel2-totales'>
                <td colSpan={3}>Total {capitalizeWords(group)}</td>
                <td className={`importe ta-right ${totales.total < 0 ? 'fcolor-red' : ''}`}>{FormatMoney(totales.total, 0)}</td>
                <td className={`importe ta-right ${totales.total < 0 ? 'fcolor-red' : ''}`}>{FormatMoney(totales.total / n1total * 100, 1)}</td>
                <td className={`importe ta-right ${totales.totalanterior < 0 ? 'fcolor-red' : ''}`}>{FormatMoney(totales.totalanterior, 0)}</td>
                <td className={`importe ta-right ${totales.totalanterior < 0 ? 'fcolor-red' : ''}`}>{FormatMoney(totales.totalanterior / n1totalanterior * 100, 1)}</td>
                <td className={`importe ta-right ${totales.variacion < 0 ? 'fcolor-red' : ''}`}>{FormatMoney(totales.variacion, 0)}</td>
                <td className={`importe ta-right ${totales.variacion < 0 ? 'fcolor-red' : ''}`}>{FormatMoney(totales.variacion / totales.totalanterior * 100, 1)}</td>
            </tr>
        </>
    )
}
